import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useBranding } from '@/lib/branding';

/**
 * Static blocked-device screen (Day 9). Shown when the backend reports
 * DEVICE_BLOCKED. Requires no API calls (the device is blocked).
 */
export default function MobileDeviceBlocked() {
  const { organisationName } = useBranding();
  return (
    <div
      className="min-h-screen bg-background flex flex-col items-center justify-center px-6 text-center"
      data-testid="mobile-device-blocked"
    >
      <div className="h-20 w-20 rounded-full bg-red-500/10 flex items-center justify-center mb-6">
        <ShieldOff className="h-10 w-10 text-red-500" />
      </div>
      <h1 className="text-xl font-semibold mb-2" data-testid="device-blocked-title">
        This device has been blocked
      </h1>
      <p className="text-sm text-muted-foreground max-w-sm mb-8" data-testid="device-blocked-message">
        Your administrator has blocked this device from accessing the {organisationName} mobile app.
        You have been signed out. Please contact your supervisor if you believe this is a mistake.
      </p>
      <a
        href="/login"
        className="text-sm font-medium text-primary underline"
        data-testid="device-blocked-login-link"
      >
        Back to sign in
      </a>
    </div>
  );
}
